import { motion, useScroll, useSpring } from "framer-motion";

const ReadingProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="reading-progress-bar"
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[3px] bg-[#cf0a0a] origin-left z-[95]"
      style={{ scaleX }}
    />
  );
};

export default ReadingProgress;
